import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import SubscripationPlanVeiwController from "../../redux/actions/SubscripationPlanAction";

const DemoRequestForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { addDemoRequest } = SubscripationPlanVeiwController();

  // Validation Schema
  const validationSchema = Yup.object({
    first_name: Yup.string().required("First name is required"),
    last_name: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().matches(/^[0-9]{10}$/, "Enter a valid 10-digit number"),
    company_name: Yup.string().required("Company name is required"),
  });

  // Initial form values
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    company_name: "",
  };

  // Submit Handler
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    dispatch(addDemoRequest(values))
      .then(() => {
        alert("✅ Demo request submitted successfully!");
        resetForm();
        onClose(); // close modal after success
      })
      .catch(() => {
        alert("❌ Something went wrong. Please try again.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-btn" onClick={onClose}>✖</button>

        <h2>Request a Demo</h2>
        <p>Fill out the form and we’ll get in touch with you soon.</p>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="demo-form">
              <div className="form-group">
                <label>First Name</label>
                <Field type="text" name="first_name" className="form-control" />
                <ErrorMessage name="first_name" component="div" className="error" />
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <Field type="text" name="last_name" className="form-control" />
                <ErrorMessage name="last_name" component="div" className="error" />
              </div>

              <div className="form-group">
                <label>Email</label>
                <Field type="email" name="email" className="form-control" />
                <ErrorMessage name="email" component="div" className="error" />
              </div>

              <div className="form-group">
                <label>Phone</label>
                <Field type="text" name="phone" className="form-control" />
                <ErrorMessage name="phone" component="div" className="error" />
              </div>

              <div className="form-group">
                <label>Company Name</label>
                <Field type="text" name="company_name" className="form-control" />
                <ErrorMessage name="company_name" component="div" className="error" />
              </div>

              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Submit Request"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default DemoRequestForm;
